// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.items-center {
  align-items: center;
}

@media (min-width: 768px) {
  .md\\:px-\\[10\\%\\] {
    padding-left: 10%;
    padding-right: 10%;
  }
}

@media (min-width: 768px) {
  .md\\:gap-y-0 {
    row-gap: 0px;
  }
}

.gap-y-6 {
  row-gap: 1.5rem;
}

.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.flex {
  display: flex;
}

.gap-x-16 {
  column-gap: 4rem;
}

.flex-col {
  flex-direction: column;
}

@media (min-width: 768px) {
  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }
}

@media (min-width: 768px) {
  .md\\:flex-row {
    flex-direction: row;
  }
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-brownBg {
  --tw-bg-opacity: 1;
  background-color: rgb(248 243 237 / var(--tw-bg-opacity));
}

.w-full {
  width: 100%;
}

@media (min-width: 768px) {
  .md\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }
}

.gap-y-3 {
  row-gap: 0.75rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-primary {
  --tw-text-opacity: 1;
  color: rgb(169 78 77 / var(--tw-text-opacity));
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.font-semibold {
  font-weight: 600;
}

.font-light {
  font-weight: 300;
}

.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(169 78 77 / var(--tw-bg-opacity));
}

@media (min-width: 768px) {
  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.rounded-full {
  border-radius: 9999px;
}

.w-fit {
  width: fit-content;
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.hover\\:bg-primary\\/80:hover {
  background-color: rgb(169 78 77 / 0.8);
}

.transition-colors {
  transition-property: color, background-color, border-color,
    text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.h-full {
  height: 100%;
}

.justify-center {
  justify-content: center;
} */
`, "",{"version":3,"sources":["webpack://./src/components/PrivateEventComponent/Section/PrivateEventSection.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA+JG","sourcesContent":["/* .px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.items-center {\n  align-items: center;\n}\n\n@media (min-width: 768px) {\n  .md\\:px-\\[10\\%\\] {\n    padding-left: 10%;\n    padding-right: 10%;\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:gap-y-0 {\n    row-gap: 0px;\n  }\n}\n\n.gap-y-6 {\n  row-gap: 1.5rem;\n}\n\n.py-16 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n\n.flex {\n  display: flex;\n}\n\n.gap-x-16 {\n  column-gap: 4rem;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n@media (min-width: 768px) {\n  .md\\:flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:flex-row {\n    flex-direction: row;\n  }\n}\n\n.bg-white {\n  --tw-bg-opacity: 1;\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\n}\n\n.bg-brownBg {\n  --tw-bg-opacity: 1;\n  background-color: rgb(248 243 237 / var(--tw-bg-opacity));\n}\n\n.w-full {\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n  .md\\:max-w-\\[50\\%\\] {\n    max-width: 50%;\n  }\n}\n\n.gap-y-3 {\n  row-gap: 0.75rem;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n  line-height: 2.25rem;\n}\n\n.text-primary {\n  --tw-text-opacity: 1;\n  color: rgb(169 78 77 / var(--tw-text-opacity));\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.font-light {\n  font-weight: 300;\n}\n\n.bg-primary {\n  --tw-bg-opacity: 1;\n  background-color: rgb(169 78 77 / var(--tw-bg-opacity));\n}\n\n@media (min-width: 768px) {\n  .md\\:mx-0 {\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.rounded-full {\n  border-radius: 9999px;\n}\n\n.w-fit {\n  width: fit-content;\n}\n\n.text-white {\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity));\n}\n\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.hover\\:bg-primary\\/80:hover {\n  background-color: rgb(169 78 77 / 0.8);\n}\n\n.transition-colors {\n  transition-property: color, background-color, border-color,\n    text-decoration-color, fill, stroke;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.justify-center {\n  justify-content: center;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
